import React, { useState, useRef, useEffect } from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const categories = [
  {
    label: "Desktop App",
    key: "desktop",
    image: "/images/desktop.png",
    preview: ["POS System", "Pharmacy System", "Clinic System"],
  },
  {
    label: "Web App",
    key: "web",
    image: "/images/web.png",
    preview: ["E-commerce Site", "Human Resource System", "Legal System"],
  },
  {
    label: "Mobile App",
    key: "mobile",
    image: "/images/mobile.png",
    preview: ["E-commerce App"],
  },
];

export default function TopCategories() {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const navigate = useNavigate();
  const previewRefs = useRef({});

  useEffect(() => {
    if (selectedCategory && previewRefs.current[selectedCategory]) {
      previewRefs.current[selectedCategory].scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [selectedCategory]);

  return (
    <Box sx={{ mt: 10, textAlign: "center" }}>
      <Typography variant="h4" gutterBottom>
        Top Categories
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {categories.map((category, idx) => (
          <Grid item xs={12} sm={4} key={category.key}>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: idx * 0.2 }}
              viewport={{ once: true, amount: 0.5 }}
            >
              {/* Category Card */}
              <Box
                onClick={() =>
                  setSelectedCategory(
                    selectedCategory === category.key ? null : category.key
                  )
                }
                sx={{
                  p: 3,
                  boxShadow: 3,
                  borderRadius: 2,
                  bgcolor: "background.paper",
                  cursor: "pointer",
                  transition: "transform 0.3s ease",
                  "&:hover": { transform: "scale(1.05)", boxShadow: 6 },
                }}
              >
                <Box
                  component="img"
                  src={category.image}
                  alt={category.label}
                  sx={{ width: "100%", maxWidth: 300, mb: 2 }}
                />
                <Typography variant="h6">{category.label}</Typography>
              </Box>

              {/* Preview Box */}
              {selectedCategory === category.key && (
                <Box
                  ref={(el) => (previewRefs.current[category.key] = el)}
                  sx={{
                    mt: 2,
                    p: 2,
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    bgcolor: "#f9f9f9",
                    textAlign: "left",
                  }}
                >
                  <Typography variant="subtitle1" gutterBottom>
                    My Projects:
                  </Typography>
                  {category.preview.map((item, i) => (
                    <Typography key={i} variant="body2">
                      • {item}
                    </Typography>
                  ))}
                  <Button
                    variant="outlined"
                    size="small"
                    sx={{ mt: 2 }}
                    onClick={() =>
                      navigate(`/projects?category=${category.key}`)
                    }
                  >
                    More
                  </Button>
                </Box>
              )}
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
